import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

import { BulkActionsPanel } from "@ryde/controls";
import { LayoutRight, LayoutRightCrudContentStatic } from "@ryde/layout";
import { bulkOperationsDrawerAF, RideCrudModeKey } from "@ryde/shared";

import { BulkPrintRides } from "./bulk-print.rides";
import { useBulkOperationsRidesActions } from "./parts";

export const BulkOperationsRidesDrawer: FC = () => {
  const entity = RideCrudModeKey.uiUnit;
  const { t } = useTranslation();

  const setBulkOperationsDrawerOpened = useSetRecoilState(
    bulkOperationsDrawerAF(entity),
  );

  const { actions, printComponentRef, printLabels } =
    useBulkOperationsRidesActions();

  return (
    <LayoutRight
      headerTitle={t(`general.BULK_ACTIONS`)}
      showFooter={false}
      closeClick={() => setBulkOperationsDrawerOpened?.(false)}
      showBackgroundImage={false}
      entity={entity}
    >
      <LayoutRightCrudContentStatic isFlush>
        <BulkActionsPanel actions={actions} />
        {printLabels && (
          <div className="displayNone">
            <BulkPrintRides ref={printComponentRef} labels={printLabels} />
          </div>
        )}
      </LayoutRightCrudContentStatic>
    </LayoutRight>
  );
};
